/*
 * This file is generated by icons/template.js
 */
const SvgStackedLineChart = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
		<path d="m2 19.99 7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01zm1.5-4.5 6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99z" />
	</svg>
);
SvgStackedLineChart.displayName = 'iconStackedLineChart';
export default SvgStackedLineChart;
